import React from 'react';

import { Text } from '@eluve/components';

interface VariantConfigDisplayProps {
  config: Record<string, unknown>;
}

export const VariantConfigDisplay: React.FC<VariantConfigDisplayProps> = ({
  config,
}) => {
  const configStr = JSON.stringify(config, null, 2);
  const isEmpty =
    !config || Object.keys(config).length === 0 || configStr === '{}';

  if (isEmpty) {
    return (
      <Text size="xs" color="tertiary">
        No config
      </Text>
    );
  }

  return (
    <pre className="max-h-48 overflow-auto rounded-sm bg-bg-gray-subtle p-2 font-mono text-xs">
      {configStr}
    </pre>
  );
};
